import { render, staticRenderFns } from "./UserFile.vue?vue&type=template&id=531453c8&scoped=true&"
import script from "./UserFile.vue?vue&type=script&lang=js&"
export * from "./UserFile.vue?vue&type=script&lang=js&"
import style0 from "./UserFile.vue?vue&type=style&index=0&id=531453c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531453c8",
  null
  
)

export default component.exports